import React from 'react';
import Footer from '../components/Contacto';
import { Helmet } from 'react-helmet';

const Nosotros: React.FC = () => {
  return (
    <div className="font-[Arial,sans-serif] bg-[#05603c] text-white">
      <div className="w-full max-w-[1200px] mx-auto px-5 py-8">
        <Helmet>
          <title>Nosotros | El Chel</title>
          <meta name="description" content="Conoce la historia y pasión detrás de El Chel — cochinita pibil desde 1978 en CDMX." />
          <meta name="keywords" content="restaurante mexicano, cochinita pibil, El Chel, CDMX" />
          <meta property="og:title" content="Nosotros | El Chel" />
          <meta property="og:description" content="Descubre nuestra misión y el sabor que nos define desde 1978." />
          <meta property="og:type" content="website" />
        </Helmet>

        <h1 className="text-[clamp(1.8rem,5vw,2.5rem)] text-white text-center mb-8 font-bold">
          ⚽ Nosotros ⚽
        </h1>

        {/* Sección 1 */}
        <div className="flex flex-col md:flex-row items-center gap-5 mb-8">
          <div className="md:w-1/2 p-5 text-justify">
            <h2 className="text-[clamp(1.5rem,4vw,2rem)] text-brand-deep mb-5">Nuestra Historia</h2>
            <p className="text-[clamp(1rem,2.5vw,1.2rem)] leading-[1.8] text-gray-200">
              Bienvenido a <strong className="text-white">El Chel</strong>, el hogar de la cochinita pibil en la
              Ciudad de México. Desde nuestros inicios, hemos estado comprometidos con llevar los sabores del
              sureste mexicano a tu mesa, con recetas que han pasado de generación en generación.
            </p>
          </div>
          <div className="md:w-1/2 p-5 text-center">
            <img
              src="/img/ressuc1.jpg"
              alt="Fachada del restaurante El Chel"
              className="w-full max-w-[400px] h-auto rounded-[10px] mx-auto shadow-brand border border-brand-deep"
            />
          </div>
        </div>

        {/* Sección 2 */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-5 mb-8">
          <div className="md:w-1/2 p-5 text-justify">
            <h2 className="text-[clamp(1.5rem,4vw,2rem)] text-brand-deep mb-5">Nuestro Origen</h2>
            <p className="text-[clamp(1rem,2.5vw,1.2rem)] leading-[1.8] text-gray-200">
              Nuestra historia comienza con un pequeño local en la zona de Coapa, donde servíamos cochinita pibil a amigos
              y vecinos. Gracias al apoyo de nuestra comunidad hemos crecido hasta
              convertirnos en un referente en la CDMX, con varias sucursales al sur de la ciudad.
            </p>
          </div>
          <div className="md:w-1/2 p-5 text-center">
            <img
              src="/img/ressuc2.jpg"
              alt="Otra vista del restaurante El Chel"
              className="w-full max-w-[400px] h-auto rounded-[10px] mx-auto shadow-brand border border-brand-deep"
            />
          </div>
        </div>

        {/* Sección 3 */}
        <div className="flex flex-col md:flex-row items-center gap-5 mb-8">
          <div className="md:w-1/2 p-5 text-justify">
            <h2 className="text-[clamp(1.5rem,4vw,2rem)] text-brand-deep mb-5">Nuestra Pasión</h2>
            <p className="text-[clamp(1rem,2.5vw,1.2rem)] leading-[1.8] text-gray-200">
              En <strong className="text-white">El Chel</strong>, nos apasiona ofrecer una experiencia única donde puedas disfrutar
              de un ambiente familiar y los sabores que nos representan. Creemos que cada platillo
              cuenta una historia, y queremos compartirla contigo.
            </p>
          </div>
          <div className="md:w-1/2 p-5 text-center">
            <img
              src="/img/ressuc3.png"
              alt="Ambiente en El Chel"
              className="w-full max-w-[400px] h-auto rounded-[10px] mx-auto shadow-brand border border-brand-deep"
            />
          </div>
        </div>

        {/* Sección 4 */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-5 mb-8">
          <div className="md:w-1/2 p-5 text-justify">
            <h2 className="text-[clamp(1.5rem,4vw,2rem)] text-brand-deep mb-5">Nuestra Misión</h2>
            <p className="text-[clamp(1rem,2.5vw,1.2rem)] leading-[1.8] text-gray-200">
              Nuestra misión es preservar y compartir la riqueza culinaria con tradición y
              un servicio excepcional para que cada cliente se sienta como en casa.
            </p>
          </div>
          <div className="md:w-1/2 p-5 text-center">
            <img
              src="/img/ressuc1.jpg"
              alt="Interior del restaurante El Chel"
              className="w-full max-w-[400px] h-auto rounded-[10px] mx-auto shadow-brand border border-brand-deep"
            />
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default Nosotros;
